/**
 * Default konfiguracija za limit sistem
 * @returns {Object} Početna konfiguracija limita
 */
export function getDefaultLimitConfig() {
    return {
        // Step 1: Tip limita i vremenski limit
        limit_definition: {
            active: null, // order, voucher, credit, money, unlimited
            settings: {
                value_per_voucher: 0,
                currency: "KM",
                orders_per_voucher: 1,
                limit_by_quantity: false,
                limit_by_value: false,
                max_orders: 1,
                max_order_value: 0,
                max_amount: 0,
                limit_amount: 0,
                quantity_in_period: 1,
                shift_limits: {
                    max_orders: [null, null, null, null],
                    max_order_value: [null, null, null, null],
                    max_amount: [null, null, null, null],
                    limit_amount: [null, null, null, null],
                    quantity_in_period: [null, null, null, null],
                },
                apply_to_all_shifts: true,
                allow_negative: false,
            }
        },

        timing: {
            active: null, // no_limit, shift, day, week, month, year, custom
            settings: {
                reset_time: null,
                reset_day: null,
                reset_month: null,
                start_date: null,
                end_date: null,
                week_start: null
            }
        },

        // Step 2: Šta može da naruči
        ordering_rules: {
            active: [], // full_meal, group_selection, daily_menu
            settings: {
                is_strict_composition: false,
                mealsPerGroup: null,
                strict_composition: {}
            }
        },

        // Step 3: Ko plaća
        payment_logic: {
            active: null, // company_only, user_only, split, company_payroll_deduct
            settings: {
                company_share: null,
                user_share: null,
                threshold: null, // Za iznos_iznad_limita_placa_korisnik logic
                monthly_cap: null,
                split_by_percentage: null,
                currency: "KM"
            }
        },

        // Step 4: Prekoračenje limita i rollover
        rollover_policy: {
            allow_transfer: false,
            block_order: false,
            settings: {
                transfer_period: "month", // day, week, month, year
                transfer_limit_value: null, // null = unlimited
                carry_debt_to_next_month: true,
                max_debt_value: null,
                notification_settings: {
                    notify_user: true,
                    message: "Prekoračili ste limit, dug ide u sledeći mesec."
                }
            }
        },

        // Step 5: Allowed restaurants (top-level on limit object, not in params)
        // limit.restaurants and limit.scope_type are managed directly on the limit

        metadata: {
            description: "",
            created_at: null,
            updated_at: null
        }
    };
}
